import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDLp5KHDGJSGVW_uBiHWJu8vUjpgHoxgQY",
  authDomain: "inombiliairiasaulo.firebaseapp.com",
  projectId: "inombiliairiasaulo",
  storageBucket: "inombiliairiasaulo.firebasestorage.app",
  messagingSenderId: "515296435866",
  appId: "1:515296435866:web:1d51a43f8c5e630f178923",
  measurementId: "G-MJBDZC66D5",
};

const app = initializeApp(firebaseConfig);

// Inicializa Firestore y Storage pasando la instancia de app
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
